import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ErrorDisplayProps {
  message?: string;
  error?: Error | string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message, error }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Typography color="error" variant="h6">
        {message || error?.toString() || t('common.error')}
      </Typography>
    </Box>
  );
};

export default ErrorDisplay; 